export default function TeleCarePlans() {
    return (
        <div>Care plans</div>
    )
}